import { render, staticRenderFns } from "./skeletonField.vue?vue&type=template&id=38d9e17b"
import script from "./skeletonField.vue?vue&type=script&lang=js"
export * from "./skeletonField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports